/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from 'react-router-dom'
import { Icon } from './Common.jsx'

export default function AuthSide({ title, subtitle, stats, chatVariant = 'A' }) {
  const navigate = useNavigate()
  return (
    <div className="auth-side">
      <div className="auth-orb auth-orb-1" />
      <div className="auth-orb auth-orb-2" />
      <div className="auth-orb auth-orb-3" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 1 }}>
        <a className="nav-logo" href="#" onClick={(e) => { e.preventDefault(); navigate('/') }}>
          <span className="nav-logo-icon"><Icon name="bar-chart-3" size={16} /></span> REPORTFLOW
        </a>
        <div className="auth-live">LIVE · 142 today</div>
      </div>

      <div className="auth-visual">
        <div className="auth-chat">
          {chatVariant === 'A' ? <>
            <div className="auth-bubble in">
              <div className="ab-tag"><Icon name="message-circle" size={11} /> REPORTFLOW BOT</div>
              Hi Aarav! You have 3 active tasks.<br />Reply <b>YES</b> to start or <b>SKIP</b> for today.<div className="ab-time">6:00 PM</div>
            </div>
            <div className="auth-typing"><span /><span /><span /></div>
            <div className="auth-bubble out">YES<div className="ab-time">6:01 PM ✓✓</div></div>
            <div className="auth-bubble in">
              <div className="ab-tag"><Icon name="message-circle" size={11} /> REPORTFLOW BOT</div>
              Task 1/3: Reviewed PR #482<br />Reply <b>done</b> / <b>progress</b> / <b>pending</b><div className="ab-time">6:01 PM</div>
            </div>
            <div className="auth-bubble out">done<div className="ab-time">6:02 PM ✓✓</div></div>
            <div className="auth-bubble ai">
              <div className="ab-tag"><Icon name="sparkles" size={11} /> AI SUMMARY</div>
              <div className="ab-task"><Icon name="check-circle-2" size={13} /> Reviewed PR #482 — done</div>
              <div className="ab-task"><Icon name="check-circle-2" size={13} /> Dashboard widget shipped — done</div>
              <div className="ab-task"><Icon name="check-circle-2" size={13} /> 3 junior 1:1s — done</div>
              <div style={{ marginTop: 6, fontSize: 11, color: '#A78BFA', fontWeight: 600 }}>3 done · no blockers · ✓ Submitted</div>
              <div className="ab-time" style={{ marginTop: 4 }}>6:03 PM</div>
            </div>
          </> : <>
            <div className="auth-bubble in">
              <div className="ab-tag"><Icon name="message-circle" size={11} /> REPORTFLOW BOT</div>
              Good morning Priya!<br />Reply <b>YES</b> to start your day, or <b>SKIP</b> if you're on leave today.<div className="ab-time">9:00 AM</div>
            </div>
            <div className="auth-bubble out">YES<div className="ab-time">9:01 AM ✓✓</div></div>
            <div className="auth-typing"><span /><span /><span /></div>
            <div className="auth-bubble in">
              <div className="ab-tag"><Icon name="message-circle" size={11} /> REPORTFLOW BOT</div>
              Hey Priya! 👋<br />Reply 'add task: &lt;description&gt;' to add a task, or I'll prompt you at 6 PM for status updates.<div className="ab-time">9:01 AM</div>
            </div>
          </>}
        </div>
      </div>

      <div className="auth-quote">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <div className="auth-stats">
          {stats.map((s, i) => <div key={i} className="auth-stat"><div className="v">{s.v}</div><div className="l">{s.l}</div></div>)}
        </div>
      </div>
    </div>
  )
}
